import React from "react";
import I18nServicePage, { RiseInfoCta } from "@/components/I18nServicePage";
import { IMG } from "@/lib/config";

export default function Rise() {
  return (
    <I18nServicePage
      i18nKey="rise"
      image={IMG.rise}
      testIdPrefix="rise"
      accentClass="text-accent-orange"
      extraCta={<RiseInfoCta />}
    />
  );
}
